import { render, staticRenderFns } from "./HbMenu.vue?vue&type=template&id=390f5696&scoped=true&"
import script from "./HbMenu.vue?vue&type=script&lang=js&"
export * from "./HbMenu.vue?vue&type=script&lang=js&"
import style0 from "./HbMenu.vue?vue&type=style&index=0&id=390f5696&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390f5696",
  null
  
)

export default component.exports